module.exports = {
  schema: {
    name: '毛胚資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        unique: true,
        name: '毛胚代碼',
      },
      name: {
        type: 'String',
        name: '毛胚名稱',
      },
      material: {
        type: 'String',
        name: '毛胚材料',
      },
      color: {
        type: 'String',
        name: '毛胚顏色',
      },
    },
  },
  index: {
    primary: {
      key: {
        name: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 90 },
        { key: 'name', width: 250 },
        { key: 'material', width: 90 },
        { key: 'color', width: 100 },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'material' }],
            [{ key: 'color' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/lensBlanks.js